import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component, Input } from '@angular/core';
import { BaseStepComponent } from '../../../base';
import { SelectItem } from 'primeng/primeng';
import { Recurso } from 'app/entity/Recurso.model';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'gerenciamento-banca-etapa2',
  templateUrl: './etapa2.component.html'
})
export class GerenciarBancaEtapa2Component extends BaseStepComponent {
  @Input() gerenciamentoBanca: any
  @Input() acao: string;
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() listaDadosInstituicao: SelectItem[];
  @Input() listaTipoAtividade: SelectItem[];
  @Input() listaPntCFC: any[] = [];
  @Input() listaPntCRC: any[] = [];
  @Input() etapaHomologacao = 3;
  @Input() mostrarCodigo: boolean;
  @Input() controladorGerenciamento = true;
  @Input() listaCapacitadora: any[] = [];
  @Input() id: number;
  @Input() recursoFiltro: RecursoFiltro
  @Input() recurso_banca: Recurso[] = [];
  listaRecurso: any;
  @Input() decisaoComissaoCrc: any;
  @Input() habilitaCamposPontuacao: boolean;
  @Input() disabledCheckbox: boolean;
  @Input() etapa: number;
  @Input() isHomologacao: boolean;

  init() {
    if (this.listaDadosInstituicao === undefined) {
      this.service.ListarTodos('instituicao').subscribe(data => {
        this.listaDadosInstituicao = data;
      });
    }
    if (this.listaTipoAtividade == undefined) {
      this.service.ListarTodos('natureza', { query: "Orientação e Banca" }).subscribe(data => {
        this.listaTipoAtividade = data;
      });
    }
    if (this.id !== undefined) {
      this.service.Obter('gerenciamento-banca/recursoList', this.id).subscribe(item => {
        this.recurso_banca = item;
      });
      this.recursoFiltro.IdModel = this.id;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-banca/crud/etapa2/etapa2.component.ts